import { z } from 'zod';

import type { IdAccountDto } from '@/services/ws-crm/src/main/resources/rest-api';
import type { IdFileInfoDto } from '@/services/ws-file-uploader/src/main/resources/rest-api';
import type { ContactShort, IdSalesPromotionDto, IdTaskDto, FileDto } from '@/services/ws-funnel/src/main/resources/rest-api';

export interface TaskFormRouteParams {
  taskId: IdTaskDto;
}

const TaskFormSearchKeyZod = z.enum(['ACCOUNT', 'PROMOTION', 'BATCH_ACCOUNTS', 'REDIRECT_TO']);
export const TaskFormSearchKey = TaskFormSearchKeyZod.Enum;
export type TaskFormSearchKey = (typeof TaskFormSearchKey)[keyof typeof TaskFormSearchKey];

export const TaskFormSearchParams = z.object({
  [TaskFormSearchKey.ACCOUNT]: z.custom<IdAccountDto>().optional(),
  [TaskFormSearchKey.PROMOTION]: z.custom<IdSalesPromotionDto>().optional(),
  [TaskFormSearchKey.BATCH_ACCOUNTS]: z.array(z.custom<IdAccountDto>()).optional(),
  [TaskFormSearchKey.REDIRECT_TO]: z.string().optional(),
});
export type TaskTableSearchParams = z.infer<typeof TaskFormSearchParams>;

export type ContactWithActive = ContactShort & {
  active?: boolean;
};

interface FileEntity {
  type: 'file';
  item: FileDto;
  id: IdFileInfoDto;
  key: string;
  fileName: string;
}

export type TaskEntity = FileEntity;
